module.exports = __webpack_public_path__ + "assets/img/tech-9.f35842e4.svg";